import { Check } from "@mui/icons-material";
import { Box, CardMedia, Skeleton } from "@mui/material";
import React, { useState } from "react";

interface ImageGalleryCardProps {
  imageUrl: string;
  isSelected: boolean;
  handleImageCardClick: () => void;
}

const ImageGalleryCard = ({
  imageUrl,
  isSelected,
  handleImageCardClick,
}: ImageGalleryCardProps) => {
  const [isLoading, setIsLoading] = useState(true);
  const [imageCardHover, setImageCardHover] = useState(false);
  return (
    <Box
      onClick={isLoading ? undefined : handleImageCardClick}
      onMouseEnter={() => setImageCardHover(true)}
      onMouseLeave={() => setImageCardHover(false)}
      sx={{
        position: "relative",
        width: "160px",
        height: "180px",
        aspectRatio: "1 / 1",
        overflow: "hidden",
        borderRadius: "8px",
        cursor: isLoading ? "default" : "pointer",
        border: `2px solid ${
          (isSelected || imageCardHover) && !isLoading
            ? "#12B6EA"
            : "transparent"
        }`,
      }}
    >
      {isLoading && (
        <Skeleton
          className="skeleton-background"
          variant="rectangular"
          width="100%"
          height="100%"
          animation="wave"
        />
      )}
      <CardMedia
        component={"img"}
        sx={{ width: "100%", height: "100%" }}
        image={imageUrl}
        alt={"My Generations Image"}
        loading="lazy"
        onLoad={() => setIsLoading(false)}
        onError={() => setIsLoading(false)}
      />
      {/* i need add overlay on image liner */}
      {(isSelected || imageCardHover) && !isLoading && (
        <Box
          sx={{
            width: "100%",
            height: "100%",
            position: "absolute",
            inset: 0,
            background:
              "linear-gradient(180deg, rgba(0, 0, 0, 0.00) 38.2%, #000 100%)",
          }}
        />
      )}
      {isSelected && (
        <Box
          sx={{
            width: "24px",
            height: "24px",
            position: "absolute",
            top: "8px",
            right: "8px",
            backgroundColor: "#12B6EA",
            borderRadius: "50%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Check
            sx={{
              width: "16px",
              height: "16px",
            }}
          />
        </Box>
      )}
    </Box>
  );
};

export default ImageGalleryCard;
